var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-link',{on:{"click":_vm.onClick}},[_c('small',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }